import React from 'react';
import MenuList from './menu';

import { Menu } from 'antd';
import Button from '@material-ui/core/Button';
import MaterialIcon from './../../components/MaterialIcon';

const SubMenu = Menu.SubMenu;

class Sidenav extends React.Component {
    name = "menuBot";
    open = { display: 'grid', gridTemplateRows: '4rem auto 10rem' };
    close = { display: 'grid', gridTemplateRows: '4rem auto 2.5rem' };
    state = {
        size: this.name,
        isUp: false,
        sidenavLayout: this.close,
        hasNavigationSubmenu: false,
        hasFooterSubmenu: false
    }

    subHelp = () => {
        if (!this.state.isUp) {
            this.setState({ size: this.name, isUp: true, sidenavLayout: this.open });
        } else {
            this.setState({ size: '', isUp: false, sidenavLayout: this.close });
        }
    }

    handleNavigationSubmenuChange = (openKeys) => {
        this.setState({ hasNavigationSubmenu: openKeys.length > 0 });
    }

    handleFooterSubmenuChange = (openKeys) => {
        this.setState({ hasFooterSubmenu: openKeys.length > 0 });
    }

    handleClick = (url, hide, link) => {
        hide();
        link(url);
    }

    render() {
        const { show, hide, link, res, profile, pinned, canPin, onPinChange } = this.props;
        const hasOpenSubmenu = this.state.hasNavigationSubmenu || this.state.hasFooterSubmenu;
        const sidenavClassName = hasOpenSubmenu ? `${show} sidenav-submenu-open` : show;
        return (
            <div className={sidenavClassName} style={this.state.sidenavLayout}>
                <div className="sidenav-header"  >
                    <div className="menu-logo"></div>
                    {canPin &&
                        <button
                            style={{ opacity: .3 }}
                            type="button"
                            className="sidenav-pin-button"
                            aria-label={pinned ? res.MENU_DESFIXAR : res.MENU_FIXAR}
                            aria-pressed={pinned}
                            title={pinned ? res.MENU_DESFIXAR : res.MENU_FIXAR}
                            onClick={() => onPinChange(!pinned)}
                        >
                            <MaterialIcon icon="push_pin" />
                        </button>
                    }
                </div>
                <MenuList profile={profile} hide={hide} link={link} res={res} size={this.state.size}
                    handleClick={this.handleClick} onSubmenuChange={this.handleNavigationSubmenuChange} />
                <div className="sidenav-footer">
                    <Menu
                        className=".nav-menu outThere"
                        mode="inline"
                        theme="dark"
                        onOpenChange={this.handleFooterSubmenuChange}
                    /*defaultOpenKeys={['sub1']}*/
                    >
                        <SubMenu
                            className=".nav-menu"
                            key="sub1"
                            onTitleClick={event => this.subHelp()}
                            title={
                                <span style={{ marginLeft: '1rem' }}>{res.FERRAMENTAS}</span>
                            }
                        >
                            <Menu.Item key="00.97">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/calibracao', hide, link) }}>
                                    <span>{res.CALIBRACAO}</span>
                                </Button>
                            </Menu.Item>
                            <Menu.Item key="00.98">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/custo', hide, link) }}>
                                    <span>{res.CUSTOHORA}</span>
                                </Button>
                            </Menu.Item>
                            <Menu.Item key="00.99">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/importar-aplicacao', hide, link) }}>
                                    <span>{res.APLICACAO + ' KMZ/KML'}</span>
                                </Button>
                            </Menu.Item>

                        </SubMenu>
                    </Menu>

                </div>
            </div>
        )
    }
}

export default Sidenav;
